import React, {PropTypes} from 'react';
import {reduxForm, Field} from 'redux-form';
import {I18n} from 'react-redux-i18n';

import FormInput from '../../common/components/FormInput';

import CareSheetPreview from './CareSheetPreview';
import StoreInfoLogo from './StoreInfoLogo';

const StoreInfoForm = ({
  handleSubmit,
  onUpload,
  storeSettings,
  submitting,
  useLogo
}) => {
  const invalidLogo = useLogo && (storeSettings.logoUrl === null);

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <fieldset disabled={useLogo}>
          <div className="row">
            <label htmlFor="example-text-input" className="col-lg-1 col-sm-2 col-form-label">{I18n.t('LINE1')}</label>
            <div className="col-lg-11 col-sm-10">
              <Field  name="line1" 
                      component={FormInput} 
                      type="text" 
                      className="form-control"  
              />
            </div>
          </div>
          <div className="row">
            <label htmlFor="example-text-input" className="col-lg-1 col-sm-2 col-form-label">{I18n.t('LINE2')}</label>
            <div className="col-lg-11 col-sm-10">
              <Field  name="line2" 
                      component={FormInput} 
                      type="text" 
                      className="form-control"  
              />
            </div>
          </div>
          <div className="row">
            <label htmlFor="example-text-input" className="col-lg-1 col-sm-2 col-form-label">{I18n.t('LINE3')}</label>
            <div className="col-lg-11 col-sm-10">
              <Field  name="line3" 
                      component={FormInput} 
                      type="text" 
                      className="form-control"  
              />
            </div>
          </div>
          <div className="row">
            <label htmlFor="example-text-input" className="col-lg-1 col-sm-2 col-form-label">{I18n.t('LINE4')}</label>
            <div className="col-lg-11 col-sm-10">
              <Field  name="line4" 
                      component={FormInput} 
                      type="text" 
                      className="form-control"  
              />
            </div>
          </div>
        </fieldset>
        <div className="logo-instead">
          <Field name="useLogo" 
                 component={FormInput}
                 type="checkbox" 
                 className="form-checkbox"/>{I18n.t('USE_LOGO_INSTEAD')}</div>

        {useLogo && <StoreInfoLogo useLogo={useLogo} logoUrl={storeSettings.logoUrl} onUpload={onUpload}/>}
        <div className="row no-gutters bottom-buttons">
          <div className="col-lg-2 col-sm-4">
            <CareSheetPreview link={storeSettings.previewUrl}/>
          </div>
          <div className="col-lg-10 col-sm-8 text-right">
            <button type="submit" className="btn btn-primary" disabled={submitting || invalidLogo}>{I18n.t('SAVE')}</button> 
          </div>
        </div>
      </form>
    </div>
  );
};

StoreInfoForm.propTypes = {
  form: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  onUpload: PropTypes.func.isRequired,
  storeSettings: PropTypes.object.isRequired,
  submitting: PropTypes.bool.isRequired,
  useLogo: PropTypes.bool
};

export default reduxForm()(StoreInfoForm);


/** WEBPACK FOOTER **
 ** ./src/modules/caresheets/components/StoreInfoForm.js
 **/